//# sourceMappingURL=vector.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/vector/vector.interface.js
// module id = 1199
// module chunks = 4